import React from 'react'
import { cn } from '@utils/safeTs'
import styles from './EditorRemovePosizioneModal.module.sass'
import useTrans from '@hooks/useTrans'
import { Alert, Button, Modal } from '@components/atoms'


interface Props {
  open?: boolean
  onClose?: () => void
  onApply?: () => void
  className?: string
}

const EditorRemovePosizioneModal = (props: Props) => {

  const { 
    open = false,
    onClose,
    onApply,
    className = '',
  } = props

  const t = useTrans()

  return (
    <Modal 
      id={'editorremoveposizionemodal'}
      open={open}
      onClose={onClose}
      title={t("Elimina posizione")}
      description={t("Sei sicuro di voler eliminare questa posizione dall'editor?")}
      buttons={(
        <>
          <Button variant="secondary" size="large" label={t("Annulla")} onClick={onClose} />
          <Button 
            variant='primary' 
            size="large" 
            label={t("Applica modifica")} 
            onClick={onApply} 
          />
        </>
      )}
      className={cn(styles.root, className)}
      mainClassName={styles.main}
      headerClassName={styles.head}
      bodyClassName={styles.body}
    >
      <Alert 
        full
        variant='danger' 
        styleVariant='background' 
        placeholder={t("<strong>Attenzione!</strong> La rimozione della posizione è definitiva ed eliminerà le configurazioni impostate finora per tale posizione")}  
      />
    </Modal>
  )
}

export default EditorRemovePosizioneModal
